import {legacy_createStore as createStore} from "redux"

const initialState = {
    sidebarShow: true,
    asideShow: false,
    asideCount: 11,
    theme: "light",
    channel: false,
    notify: JSON.parse(localStorage.getItem("notify")) || {
        agencies: 0,
        alerts: {
            new: 0,
            checked: 0
        },
        invoices: 0,
        orders: 0,
        pretenses: 0,
        tasks: 0,
    },
    hint: JSON.parse(localStorage.getItem("hint")) || {
        stepsEnabled: false,
        initialStep: 0,
        hintsCount: [],
        steps: []
    },
    spiderman: JSON.parse(localStorage.getItem("spiderman")) || null
}

const changeState = (state = initialState, {type, ...rest}) => {
    switch (type) {
        case "set":
            return {...state, ...rest}
        default:
            return state
    }
}

const store = createStore(changeState)
export default store
